export default __webpack_public_path__ + "static/media/image.x-o-concepts.592bfb1b.png";